import React, { useMemo } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { legacyTabSlugToPath, PLATFORM_CONSOLE_PATH } from "./platformConsoleRoutes";

/**
 * Rota índice /platform/xprobase: redireciona ?tab= legado ou vai para Workspaces.
 */
const LegacyPlatformRedirect = () => {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  const to = useMemo(() => {
    if (tab) return legacyTabSlugToPath(tab);
    return PLATFORM_CONSOLE_PATH.workspaces;
  }, [tab]);

  return <Navigate to={to} replace />;
};

export default LegacyPlatformRedirect;
